import styled, { FlattenSimpleInterpolation } from 'styled-components';
import { ListItem as UnstyledListItem, List as UnstyledList } from '@lux/list';
import { screenSizes, Spacer, FunctionColor, BrandColor } from '@lux/tokens';

export const respondFrom = (screenSize: number) => (
    styles: string | FlattenSimpleInterpolation,
) => {
    return `@media (min-width: ${screenSize}px) {
        ${styles}
    }`;
};

export const ListItem = styled(UnstyledListItem)`
    font-family: var(--font-default);
    color: ${FunctionColor.function100};
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.02em;
`;

export const NestedItem = styled(UnstyledListItem)`
    padding-left: 16px;
    padding-right: ${Spacer.M};
`;

export const List = styled(UnstyledList)`
    margin-left: ${Spacer.M};
    padding-right: ${Spacer.M};
`;

export const PageWrapper = styled.div`
    padding-top: ${props => (props.theme.paddingZero ? '0' : Spacer.M)};
    display: flex;
    flex-direction: row;
    height: auto;
    padding-bottom: 50px;
    flex-wrap: wrap;
    width: 100%;
`;

export const NestedList = styled(UnstyledList)`
    width: 60%;
    padding: 0;
    margin: 0;
    padding-top: ${Spacer.S};
    padding-bottom: 80px;
`;

export const Header = styled.h1`
    font-family: var(--font-heading);
    font-weight: 700;
    color: ${FunctionColor.function100};
    font-size: 26px;
    line-height: 34px;
    display: block;
    margin-left: 0px;
    ${respondFrom(screenSizes.xs)(`
        margin-left: ${Spacer.XL};
    `)};
`;

export const Content = styled.div`
    flex: 1;
    margin-left: 0px;
    overflow-x: hidden;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.02em;
    display: block;
    ${respondFrom(screenSizes.xs)(`
        margin-left: ${Spacer.XL};
    `)};
    h3 {
        font-family: var(--font-default);
        color: ${FunctionColor.function100};
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0.04em;
    }
    img {
        max-width: 100%;
        height: auto;
    }
    font {
        color: ${BrandColor.primary};
    }
    font:hover {
        text-decoration: underline;
    }
    p {
        text-align: start !important;
        white-space: pre-wrap;
    }

    a {
        text-decoration: none;
        color: ${BrandColor.primary};
        padding: 0;
    }

    .bordered-container {
        :not(:last-child) {
            border-bottom: 1px solid ${FunctionColor.function10};
        }
        padding-top: ${Spacer.S};
    }

    .row-fluid {
        display: block;
        ${respondFrom(screenSizes.xs)(`
            display: flex;
    `)};
    }
    .span6 {
        flex: 50%;
        margin-right: ${Spacer.M};
    }
    .sizehelper-nav-image {
        width: 100%;
        margin-right: 0px;
        display: inline-block;
        margin-bottom: ${Spacer.XXS};
        ${respondFrom(screenSizes.xs)(`
            width: 45%;
            margin-right: ${Spacer.M};
        `)}
    }
    .size-chart-paragraph {
        text-align: start !important;
        white-space: pre-wrap;
        word-break: break-word;
        width: 45%;
        ${respondFrom(screenSizes.xs)(`
            width: 55%;
        `)};
        ${respondFrom(screenSizes.sm)(`
            width: auto;
        `)};
    }
    .margin-small-top {
        display: block;
        padding-bottom: ${Spacer.S};
    }
    .accordion-heading {
        font-family: var(--font-default);
        color: ${FunctionColor.function100};
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0.04em;
        position: relative;
    }
    .collapsed {
        pointer-events: auto;
        color: ${FunctionColor.function100};
        font-weight: 400;
        font-size: 14px;
    }
    .collapsed > * {
        pointer-events: none;
    }
    .collapse {
        display: none;
    }
    .accordion-heading::after {
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24px' height='24px'><path fill='black' d='M7.558 3.558a.625.625 0 0 1 .884 0l8 8a.625.625 0 0 1 0 .884l-8 8a.625.625 0 1 1-.884-.884L15.116 12 7.558 4.442a.625.625 0 0 1 0-.884z'></path></svg>");
        content: ' ';
        transform: rotate(90deg);
        position: absolute;
        right: 15px;
        top: 3px;
    }

    .expand-accordion::after {
        transition: 0.3s ease-in-out;
        transform: rotate(270deg);
    }

    .expand {
        display: block;
    }
    .zTable {
        width: 80%;
        td {
            padding: ${Spacer.XS};
            padding-left: ${Spacer.M};
        }
    }
    .mobileShow {
        display: none;
    }
    .sizehelper-footer {
        padding-bottom: 16px;
    }
    iframe {
        display: block;
        margin: 0 auto;
    }
`;

export const Wrapper = styled.div`
    &.is-webview {
        margin-top: 30px;
    }
    .grid-page-layout {
        ${respondFrom(screenSizes.xs)(`
            padding-left: 0 16px;
            padding-right: calc(16px - 100vw + 100%)
                `)};
        ${respondFrom(screenSizes.sm)(`
            padding-left: 0 32px;
            padding-right: calc(32px - 100vw + 100%)
                `)};
        ${respondFrom(screenSizes.md)(`
            padding-left: 0 64px;
            padding-right: calc(64px - 100vw + 100%)
                `)};
        ${respondFrom(screenSizes.lg)(`
            padding-left: 0 124px;
            padding-right: calc(124px - 100vw + 100%)
            `)};
    }
`;

export const ContactItem = styled.div`
    display: flex;
    justify-content: flex-start;
    padding-bottom: ${Spacer.M};
    }
`;

export const ContactText = styled.div`
    margin-left: ${Spacer.XS};
    display: block;
    margin-top: 2px;
    display: inline-block > * {
        &:first-child {
            margin-bottom: ${Spacer.XS};
        }
    }
`;

export const ColumnWrapper = styled.div`
    display: none;
    flex-direction: column;
    flex: 1;
    ${respondFrom(screenSizes.xs)(`
        display: flex;
`)};
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 2;
`;

export const FormWrapper = styled.div`
    margin-left: 0px;
`;

export const StyledAnchor = styled.a`
    color: ${FunctionColor.function100};
    :hover {
        text-decoration: underline;
        color: ${BrandColor.primary};
    }
`;

export const Table = styled.table`
    padding-left: ${Spacer.L};
    margin: ${Spacer.S} 0;
    td {
        padding: ${Spacer.XS};
        padding-left: ${Spacer.M};
    }
    border-collapse: collapse;
    .odd {
        background-color: ${FunctionColor.function10};
    }
    .header {
        width: 100px;
    }
`;
